/**
 * AI Processing Display Status
 *
 * Per Mudassir (June-02): the stored AI Evaluation GET APIs now return an
 * `evaluationStatus` (and `talentProfileStatus`) object shaped as
 * { status: AiProcessingDisplayStatusEnum, lastSuccessfulAt: string | null }.
 *
 * It tells the FE whether the displayed AI data is fresh, may be out of date,
 * is currently being refreshed, or failed — so we can show a soft alert
 * instead of silently rendering stale numbers.
 */
export const AiProcessingDisplayStatusEnum = Object.freeze({
  Current: 0, // AI data is up to date — no alert needed
  Stale: 1, // A previous successful result exists, but the latest refresh failed/pending
  Processing: 2, // AI refresh is currently pending/running
  Failed: 3, // AI processing failed and there is no previous successful result
});
